/**
 * @class TableRow
 *
 * Contains data for all rows to be displayed
 *
 * @property {TableCell[]} data - data to be displayed in the table row
 * @property {string} className - specific classes to be applied to this table row
 * @property {undefined | string | number} key - unique key for table row
 * @property {object} elementProps - other props to pass into table row element (e.g. onClick, onScroll)
 * @property {TableRow[] | null} [subRows] - sub rows
 * @property {boolean} [expandedSubRows] - whether sub rows are shown
 */
export default class TableRow {
    /**
     *
     * @param {TableCell[]} [data] - data to be displayed in the table row
     * @param {string} [className] - specific classes to be applied to this table row
     * @param {string | number} [key] - unique key for table row
     * @param {object} [elementProps] - other props to pass into table row element (e.g. onClick, onScroll)
     * @param {TableRow[] | null} [subRows] - sub rows
     * @param {boolean} [expandedSubRows] - whether sub rows are shown
     */
    constructor(
        data = [],
        className = "",
        key = undefined,
        elementProps = {},
        subRows = null,
        expandedSubRows = false
    ) {
        this._className = className;
        this._data = data;
        this._key = key;
        this._elementProps = elementProps;
        this._subRows = subRows;
        this._expandedSubRows = expandedSubRows;
    }

    /**
     * toggles sub rows expansion
     */
    toggleExpandedSubRows = () => {
        this._expandedSubRows = !this._expandedSubRows;
    };

    /**
     * @returns {string}
     */
    get className() {
        return this._className;
    }

    /**
     * @returns {*[]}
     */
    get data() {
        return this._data;
    }

    /**
     * @returns {undefined | string | number}
     */
    get key() {
        return this._key;
    }

    /**
     * @returns {{}}
     */
    get elementProps() {
        return this._elementProps;
    }

    /**
     * @returns {TableRow[] | null}
     */
    get subRows() {
        return this._subRows;
    }

    /**
     * @returns {boolean}
     */
    get expandedSubRows() {
        return this._expandedSubRows;
    }
}
